import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import AuctionsPage from "@/pages/AuctionsPage";
import AuctionDetailPage from "@/pages/AuctionDetailPage";
import CreateAuctionPage from "@/pages/CreateAuctionPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import DashboardPage from "@/pages/DashboardPage";
import AdminPage from "@/pages/AdminPage";
import PaymentReturnPage from "@/pages/PaymentReturnPage";
import AuthCallback from "@/pages/AuthCallback";
import TermsPage from "@/pages/TermsPage";

export default function App() {
  const location = useLocation();
  // Synchronously detect Google OAuth callback in URL fragment
  if (location.hash?.includes("session_id=")) {
    return <div className="App min-h-screen bg-white"><AuthCallback /></div>;
  }
  return (
    <div className="App min-h-screen bg-white">
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/auctions" element={<AuctionsPage />} />
          <Route path="/auction/:slug" element={<AuctionDetailPage />} />
          <Route path="/sell" element={<CreateAuctionPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/payment/return" element={<PaymentReturnPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Route>
      </Routes>
    </div>
  );
}
